function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Form, Input, Alert, Spin, Button, Select, Space, Divider, Breadcrumb, notification } from 'antd';
import { Container, Row, Col } from "react-bootstrap";
import { Building, GlobeEuropeAfrica, GeoAltFill, TelephoneFill, Globe, EnvelopeAtFill } from "react-bootstrap-icons";
import Common from "../includes/Common";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var Option = Select.Option;

var EditBusinessAccount = function EditBusinessAccount(_ref) {
  var _ref$businessAccountI = _ref.businessAccountId,
      businessAccountId = _ref$businessAccountI === void 0 ? null : _ref$businessAccountI,
      handleUpdate = _ref.handleUpdate;

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFormPrecessing = _useState2[0],
      setIsFormProcessing = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      businessAccount = _useState6[0],
      setBusinessAccount = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      successMessage = _useState8[0],
      setSuccessMessage = _useState8[1];

  var _useState9 = useState(true),
      _useState10 = _slicedToArray(_useState9, 2),
      isDataLoading = _useState10[0],
      setIsDataLoading = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      countryList = _useState12[0],
      setCountryList = _useState12[1];

  var _useState13 = useState(null),
      _useState14 = _slicedToArray(_useState13, 2),
      countryId = _useState14[0],
      setCountryId = _useState14[1];

  var _useState15 = useState([]),
      _useState16 = _slicedToArray(_useState15, 2),
      depList = _useState16[0],
      setDepList = _useState16[1];

  var onFinish = function onFinish(values) {
    setIsFormProcessing(true);
    setErrorMessage('');
    setSuccessMessage('');
    var formData = new FormData();
    formData.append('country_id', values.country_id);
    formData.append('business_label', values.business_label);
    formData.append("mobile", values.mobile);
    formData.append("email", values.email);
    formData.append("id", Common.currentUser.id);
    formData.append("user_id", Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'editbusinessaccount', formData).then(function (response) {
      setIsFormProcessing(false);

      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        handleUpdate();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setIsFormProcessing(false);
      setErrorMessage('Une erreur est survenue');
    });
  };

  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + "getaccount/" + businessAccountId + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setBusinessAccount(response.data.account);
        form.setFieldsValue({
          business_label: response.data.account.business_label,
          mobile: response.data.account.mobile,
          email: response.data.account.email,
          address: response.data.account.address
        });
      } else {
        notification.error({
          message: "Erreur !",
          description: response.data.message
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur !",
        description: "Une erreur est survenue"
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  useEffect(function () {
    axios.get(Common.baseApiUrl + "getactivecountries").then(function (response) {
      if (response.data.status == 200) {
        response.data.countries.forEach(function (e) {
          setCountryList(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: e.id,
              label: e.country_name + "(" + e.country_code + ")"
            }]);
          });
        });
        if (response.data.countries.length > 0) form.setFieldsValue({
          country_id: response.data.countries[0].id
        });
        setCountryId(response.data.countries[0].id);
      }
    })["catch"](function (error) {});
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [errorMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      type: "error",
      message: errorMessage,
      showIcon: true
    }), successMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
      type: "success",
      message: successMessage,
      showIcon: true
    }), /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "vertical",
      onFinish: onFinish,
      children: [/*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsxs(Col, {
          lg: 12,
          md: 12,
          children: [/*#__PURE__*/_jsx(Form.Item, {
            name: "business_label",
            label: "Nom de votre structure",
            rules: [{
              required: true,
              message: 'Ce champ est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {
              prefix: /*#__PURE__*/_jsx(Building, {})
            })
          }), /*#__PURE__*/_jsx(Form.Item, {
            name: "mobile",
            label: "Contact mobile",
            rules: [{
              required: true,
              message: 'Ce champ est obligatoire'
            }],
            children: /*#__PURE__*/_jsx(Input, {
              prefix: /*#__PURE__*/_jsx(TelephoneFill, {})
            })
          }), /*#__PURE__*/_jsx(Form.Item, {
            name: "email",
            label: "E-mail",
            children: /*#__PURE__*/_jsx(Input, {
              prefix: /*#__PURE__*/_jsx(EnvelopeAtFill, {})
            })
          }), /*#__PURE__*/_jsx(Form.Item, {
            name: "address",
            label: "Adresse",
            children: /*#__PURE__*/_jsx(Input, {
              prefix: /*#__PURE__*/_jsx(GeoAltFill, {})
            })
          }), /*#__PURE__*/_jsx(Form.Item, {
            name: "website",
            label: "Site web",
            children: /*#__PURE__*/_jsx(Input, {
              prefix: /*#__PURE__*/_jsx(Globe, {})
            })
          }), /*#__PURE__*/_jsx(Form.Item, {
            name: "country_id",
            label: "Pays",
            children: /*#__PURE__*/_jsx(Select, {
              options: countryList,
              disabled: true,
              prefix: /*#__PURE__*/_jsx(Globe, {
                size: 18
              })
            })
          })]
        })
      }), /*#__PURE__*/_jsx(Space, {
        direction: "horizontal",
        children: /*#__PURE__*/_jsx(Form.Item, {
          children: /*#__PURE__*/_jsx(Button, {
            disabled: businessAccount == null,
            loading: isFormPrecessing,
            htmlType: "submit",
            type: "primary",
            children: /*#__PURE__*/_jsx("b", {
              children: "Sauvegarder"
            })
          })
        })
      })]
    })]
  });
};

export default EditBusinessAccount;